import React from 'react';

import { Inject } from '@odinjs/odin';

import { FetchAPI, FieldAPI, FieldsetAPI, FormAPI } from '@philips-emr/tws-components';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnBeforeSubmit, OnCancel, OnClick, OnEdit } from '@philips-emr/tws-core/lib/client';
import { AbortableSubmitEvent, EditEvent, FetchEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, ModalService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';

import { FragmentNames, ReceberBoletosEmailAliases, RootRoutes } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { DialogService, ToastService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.RECEBER_BOLETOS_EMAIL })
export default class ReceberBoletosEmailController extends BaseController {

  @Inject(ReceberBoletosEmailAliases.FETCH)
  private fetch: FetchAPI;
  @Inject(ReceberBoletosEmailAliases.FORM)
  private form: FormAPI;
  @Inject(ReceberBoletosEmailAliases.FIELDSET_VIEWING)
  private fieldsetViewing: FieldsetAPI;
  @Inject(ReceberBoletosEmailAliases.FIELD_TERMO)
  private fieldTermo: FieldAPI;

  @OnAfterFetch(ReceberBoletosEmailAliases.FETCH)
  onAfterFetch({ data }: FetchEvent): void {
    if (data) {
      const { mensagem, nrSeqTermo } = data as { mensagem: string, nrSeqTermo: number };

      this.fieldsetViewing.setVisible(!!mensagem);
      this.fieldTermo.setVisible(!!nrSeqTermo);
      setTimeout(() => this.form.setEditing(!mensagem), 15);
    }
  }

  @OnEdit(ReceberBoletosEmailAliases.FORM)
  onEdit({ target }: EditEvent): void {
    const api = target as FormAPI;
    api.setRecord({ ...api.getRecord(), termo: false });
  }

  @OnBeforeSubmit(ReceberBoletosEmailAliases.FORM)
  onBeforeSubmit({ abort, target }: AbortableSubmitEvent): void {
    const api = target as FormAPI;

    if (api.isValid()) {
      const isSubmittable: Promise<boolean> = DialogService.confirm('beneficiary.mensagem-confirmar-email-boleto')
        .then(() => this.submit(api.getRecord()))
        .catch(() => true);

      abort(isSubmittable);
    }
  }

  @OnClick(ReceberBoletosEmailAliases.LINK_TERMOS)
  onLinKTermoClick(): void {
    const { nrSeqBeneficiario } = this.context.getBulkData();
    const { nrSeqTermo } = this.form.getRecord();
    if (nrSeqTermo) {
      void HttpService.get<{ dsTermo: string }>(Endpoints.GET.TERMO_RESPONSABILIDADE_BOLETO, { nrSeqTermo, nrSeqBeneficiario })
        .then(({ body }) => {
          if (body) {
            const { dsTermo } = body;
            ModalService.openDefault({
              closeable: true,
              theme: ThemeTonalRange.ULTRA_LIGHT,
              title: 'beneficiary.termo-responsabilidade',
              children: (<div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: dsTermo }} />),
            });
          }
        })
        .catch(response => ToastService.open(response));
    }
  }

  private submit(body: {}): Promise<boolean> {
    const { nrSeqBeneficiario } = this.context.getBulkData();

    return HttpService.post<{}>(Endpoints.POST.BOLETOS_POR_EMAIL, { nrSeqBeneficiario }, { body })
      .then(response => {
        ToastService.open(response);
        this.fetch.forceFetch();
        return false;
      })
      .catch(response => {
        ToastService.open(response);
        return true;
      });
  }

  @OnCancel(ReceberBoletosEmailAliases.FORM)
  onCancelFormSolic(): void {
    applicationContext.redirect(RootRoutes.ROUTE_LOGIN);
  }
}
